<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Dil Listesi">
          <!-- <b-alert variant="warning" show class="mb-0">
              <div class="alert-body mb-2">
                <span
                  ><strong>Not:</strong> Eklenecek içerik adı ve arama motoru
                  bağlantı linki benzersiz olmalıdır...</span
                >
              </div>
            </b-alert> -->
          <b-button
            class="float-right"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            :to="`/language/create`"
          >
            Yeni Dil Ekle
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Diller">
          <b-form>
            <b-row>
              <b-col cols="12">
                <table class="table b-table table-responsive">
                  <thead>
                    <th>#</th>
                    <th>BAYRAK</th>
                    <th>DİL</th>
                    <th>DURUM</th>
                    <th>OLUŞTURMA TARİHİ</th>
                    <th>İŞLEMLER</th>
                  </thead>
                  <draggable
                    v-model="languages"
                    class="cursor-move"
                    tag="tbody"
                    @change="outputData"
                  >
                    <tr v-for="language in languages" :key="language.id">
                      <td>{{ language.id }}</td>
                      <td>
                        <b-img :src="language.flag" width="32" />
                      </td>
                      <td>{{ language.name }}</td>
                      <td class="text-center">
                        <b-badge v-if="language.isDraft" variant="light-warning">
                         Pasif
                        </b-badge>
                        <b-badge   v-else variant="light-success">
                          Aktif
                        </b-badge>
                      </td>
                      <td>{{ language.createdAt }}</td>

                      <td>
                        <b-button-group>
                          <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-warning"
                            class="btn-icon rounded-circle mr-1"
                            :to="`/language/edit/${language.id}`"
                          >
                            <feather-icon icon="EditIcon" />
                          </b-button>
                          <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-danger"
                            class="btn-icon rounded-circle"
                            @click="deleteConfirmText(language.id)"
                          >
                            <feather-icon icon="TrashIcon" />
                          </b-button>
                        </b-button-group>
                      </td>
                    </tr>
                  </draggable>
                  <thead>
                    <th>#</th>
                    <th>BAYRAK</th>
                    <th>DİL</th>
                    <th>DURUM</th>
                    <th>OLUŞTURMA TARİHİ</th>
                    <th>İŞLEMLER</th>
                  </thead>
                </table>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Ripple from "vue-ripple-directive";
import draggable from "vuedraggable";
import {
  BRow,
  BCol,
  BImg,
  BCard,
  BForm,
  BBadge,
  BAlert,
  BButton,
  BAvatar,
  BCardText,
  BButtonGroup,
  BListGroupItem,
  BButtonToolbar,
} from "bootstrap-vue";
import settings from "../../../settings";
import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BCard,
    BForm,
    BAlert,
    BBadge,
    BButton,
    BAvatar,
    BCardText,
    BButtonGroup,
    BListGroupItem,
    BButtonToolbar,
    draggable,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      request: [],
      languages: [],
    };
  },
  watch: {},
  methods: {
    outputData() {
      this.updateSubmit();
    },
    updateSubmit() {
      Object.entries(this.languages).forEach(([key, value]) => {
        let langugesOrder = {
          id: value.id,
          order: parseInt(key),
        };
        this.request.push(langugesOrder);
      });
      endpoints
        .putLanguagesOrder({ languages: this.request }, this.$i18n.locale, () => {})
        .then((data) => {
          this.$swal({
            icon: "success",
            title: "Güncelleme başarılı!",
            text: "Dil sıralaması güncellendi.",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getLanguages() {
      endpoints
        .getLanguages(null, this.$i18n.locale, () => {})
        .then((data) => {
          this.languages = [...data.response];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteConfirmText(id) {
      this.$swal({
        title: "Sil?",
        text: "Dili silmek istediğinize emin misiniz?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Vazgeç!",
        confirmButtonText: "Kaydet!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteSubmit(id);
        }
      });
    },
    deleteSubmit(id) {
      endpoints
        .deleteLanguage(id, this.$i18n.locale, () => {})
        .then((data) => {
          this.getLanguages();
          this.$swal({
            icon: "success",
            title: "Silme başarılı!",
            text: "Dil silindi",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.getLanguages();
  },
};
</script>
<style>
.draggable-card {
  margin-bottom: 0;
}

.draggable-card > .card-body {
  padding: 10px;
}

.draggable-card > .card-body > .card-title {
  margin-bottom: 0;
  font-size: 1rem;
}

.tree-node {
  border: 0 !important;
}
</style>
